import { jsx as h } from "react/jsx-runtime";
import { isBefore as k } from "date-fns";
import { useState as d } from "react";
import { BaseDatePicker as B } from "../BaseDatePicker.js";
const l = (t, n, f) => {
  const m = t && k(f, t);
  return !t || m || t && n;
}, F = ({
  value: t,
  onDayClick: n,
  onDayMouseEnter: f,
  onDayMouseLeave: m,
  onChange: a,
  ...u
}) => {
  const D = {
    from: t.from,
    to: t.to
  }, [o, c] = d(D), [g, s] = d(t.to), p = () => {
    c({ from: void 0, to: void 0 }), s(void 0);
  }, v = (e, r, i) => {
    if (n && (e.setHours(12), n(e, r, i)), !r.disabled) {
      if (o?.from && o?.to && e >= o?.from && e <= o?.to) {
        p();
        return;
      }
      if (l(o?.from, o?.to, e)) {
        c({ from: e, to: void 0 }), s(void 0);
        return;
      }
      c((R) => ({ from: R?.from, to: e })), s(e), o?.from !== void 0 && e !== void 0 && (o?.from.setHours(12), e.setHours(12), a({ from: o?.from, to: e }));
    }
  }, H = (e, r, i) => {
    f && (e.setHours(12), f(e, r, i)), l(o?.from, o?.to, e) || s(e);
  }, S = (e, r, i) => {
    m && (e.setHours(12), m(e, r, i)), o?.to || s(void 0);
  };
  return /* @__PURE__ */ h(
    B,
    {
      selected: o,
      modifiers: {
        enteredDays: { from: o?.from, to: g },
        // dates added to potential selection
        firstDay: !o?.to && o?.from ? o?.from : !1
        // mark first day if no end date was selected yet
      },
      modifiersClassNames: { enteredDays: "rdp-range_entered", firstDay: "rdp-range_first_day" },
      onDayClick: v,
      onDayMouseEnter: H,
      onDayMouseLeave: S,
      mode: "range",
      ...u
    }
  );
};
export {
  F as InlineDateRangePicker
};
//# sourceMappingURL=InlineDateRangePicker.js.map
